import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerProject } from '../../customer-project.interface';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';
import { Utils } from '../../utils.class';

@Component({
    selector: 'app-customer-project-description-dialog',
    templateUrl: './customer-project-description-dialog.component.html',
    standalone: false,
})
export class CustomerProjectDescriptionDialogComponent implements OnInit {
    project: CustomerProject;

    form: FormGroup;

    constructor(
        private customerProjectService: CustomerProjectService,
        private dialog: MatDialogRef<CustomerProjectDescriptionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: {
            project?: CustomerProject;
        }
    ) {
        this.project = data.project;
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            description: new FormControl(this.project.description, Validators.required),
        });
    }

    save() {
        Utils.triggerValidationP(this.form)
            .then(() => {
                Object.assign(this.project, this.form.value);
                this.customerProjectService.saveProject(this.project).subscribe(data => this.dialog.close(data.data));
            })
            .catch(() => {});
    }
}
